import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _CardContent;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var CardContent = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_CardContent = /*#__PURE__*/function (_Component) {
  function CardContent() {
    _classCallCheck(this, CardContent);
    return _callSuper(this, CardContent, arguments);
  }
  _inherits(CardContent, _Component);
  return _createClass(CardContent, [{
    key: "render",
    value: function render() {
      return jsx(View, {
        as: "div"
      }, jsx("div", {
        css: _objectSpread(_objectSpread({}, this.props.styles.content), this.props.customStyles),
        className: this.props.className
      }, this.props.children));
    }
  }]);
}(Component), _defineProperty(_CardContent, "displayName", 'CardContent'), _defineProperty(_CardContent, "componentId", "Quizzes".concat(_CardContent.displayName)), _defineProperty(_CardContent, "propTypes", {
  children: PropTypes.node.isRequired,
  customStyles: PropTypes.object,
  styles: PropTypes.object,
  className: PropTypes.string
}), _defineProperty(_CardContent, "defaultProps", {
  customStyles: {},
  className: ''
}), _CardContent)) || _class);
export default CardContent;